<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <b-link
                        v-if="role ==='admin'"
                        @click="toggleShowForm"
                        :class="(showForm ? 'btn-danger' : 'btn-primary')"
                        class="btn btn-round">
                    {{ (showForm ? 'close' : '+ Neue Kategorie') }}
                </b-link>
            </template>
        </navbar>
        <!--navbar-->

        <template v-if="showForm">
            <form-subcategory :parentCategoryId="categoryParent"></form-subcategory>
        </template>
        <!--Form-->

        <template v-else>
            <template v-if="items.length > 0">
                <draggable v-model="items" group="items"
                           @update="updateOrder"
                           handle=".handle"
                           @start="drag=true"
                           @end="drag=false">
                    <b-card
                            v-for="(item,index) in items"
                            :key="index"
                            :class="{'border border-danger':item.is_hide === 'yes'}">
                        <b-media left-align vertical-align="center">
                            <template #aside>
                                <b-img :src="item.image_url"
                                       style="object-fit: contain"
                                       height="45"
                                       width="80" alt="placeholder"></b-img>
                            </template>
                            <h5 class="mt-0 mb-1 font-weight-bold">{{item.title}}</h5>
                            <p class="mb-0">
                                <b-link
                                        @click="editItem(item)"
                                        class="mr-4">
                                    <span class="material-icons font-14">create</span>
                                    <span>edit</span>
                                </b-link>
                                <b-link
                                        v-if="role ==='admin'"
                                        class="text-danger" @click.prevent="deleteCategory(item.id)">delete
                                </b-link>

                            </p>

                            <div class="text-right">
                            <span class="mr-3 handle">
                                <span class="material-icons">drag_handle</span>
                            </span>
                            </div>
                        </b-media>
                    </b-card>
                </draggable>

            </template>
        </template>
        <!--List-->

    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notification from '../../Services/Notification/Nottification'
    import draggable from 'vuedraggable'
    import FormSubcategory from './Form.vue';
    import {EventBus} from "../../Services/Eventbus/event-bus";


    export default {
        name: "Index",
        components: {
            FormSubcategory,
            Navbar,
            draggable
        },
        data() {
            return {
                items: [],
                showForm: false,
                role: null,
                categoryParent: 0,
            }
        },
        methods: {
            toggleShowForm() {
                this.showForm = !this.showForm;
            },
            editItem(myItem) {
                this.showForm = true;
                setTimeout(() => {
                    EventBus.$emit("updateSubcategory", myItem);
                }, 1000);

            },
            deleteCategory(id) {
                if (confirm(this.$t('alertText'))) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'subcategory/delete/' + id)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.getCategories();
                                Notification.success(response.data.message)
                            } else {
                                Notification.error(response.data.message)

                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
            getCategories() {
                if (this.$route.params.categoryid) {
                    this.categoryParent = parseInt(this.$route.params.categoryid);
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'subcategory/index/' + this.$route.params.categoryid)
                        .then(response => {
                            if (response.data.status_code === Http.ok()) {
                                this.$Progress.finish();
                                this.productCount = response.data.data.productCount;
                                this.items = response.data.data.items;
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
            updateOrder() {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'subcategory/update/order/items', {
                    items: this.items
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.getCategories();
                            Notification.success(response.data.message)
                        } else {
                            Notification.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
        },
        created() {
            let myThis = this;
            this.getCategories();

            EventBus.$on('updateSubcategorySuccess', function (payload) {
                if (payload === "yes") {
                    myThis.showForm = false;
                    myThis.getCategories();
                }
            });
        },
        mounted() {
            this.role = localStorage.getItem('role');
        }
    }
</script>

<style scoped>

</style>